// need a map function that integrates into the Formie form

import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import ZoomControl from "@mapbox-controls/zoom";
import "@mapbox-controls/zoom/src/index.css";

const mapImages = [];

document.addEventListener("onFormieInit", (event) => {

	mapboxgl.accessToken =
		"pk.eyJ1IjoiYWhvY2tlbWV5ZXIiLCJhIjoiY20wZTYwMXkwMDM1ZzJub3E5aWN4YnpqdSJ9.wlxlUUyqymxnzm_AdjeILQ";

		const style = 'mapbox/satellite-streets-v12'

	const map = new mapboxgl.Map({
		container: "mapbox",
		style: `mapbox://styles/${style}`,
		center: [-97.604007, 32.5705373],
		zoom: 8.8,
	});
	map.addControl(new ZoomControl(), "bottom-right");

	const search = new MapboxGeocoder({
		accessToken: mapboxgl.accessToken,
		mapboxgl: mapboxgl,
		placeholder: "Property Address",
	});

	map.addControl(search);

	// Listen for the 'result' event
	search.on('result', (e) => {
			const result = e.result;

			// Access the address parts
			const addressParts = {
					fullAddress: result.place_name,
					streetAddress: result.address,
					city: result.context.find(c => c.id.startsWith('place'))?.text,
					state: result.context.find(c => c.id.startsWith('region'))?.text,
					postalCode: result.context.find(c => c.id.startsWith('postcode'))?.text,
					country: result.context.find(c => c.id.startsWith('country'))?.text
			};

			populateFormieFormAddressFields(event.detail.formie.$forms[0], addressParts);
			// You can now use addressParts as needed in your application
	});



	const draw = new MapboxDraw({
		displayControlsDefault: false,
		// Select which mapbox-gl-draw control buttons to add to the map.
		controls: {
			polygon: true,
			trash: true,
		},
		// Set mapbox-gl-draw to draw by default.
		// The user does not have to click the polygon control button first.
		defaultMode: "draw_polygon",
	});

	map.addControl(draw, "top-left");

	map.on("draw.create", updateArea);
	map.on("draw.delete", updateArea);
	map.on("draw.update", updateArea);

	function updateArea(e) {
		if (e.features.length > 0) {
			const img = document.createElement("img");
			const imageUrl = `https://api.mapbox.com/styles/v1/${style}/static/geojson(${getGeoJson(
				e.features[0]
			)})/auto/800x800?access_token=${mapboxgl.accessToken}`;
			img.src = imageUrl;

			const newImage = {
				id: e.features[0].id,
				src: imageUrl
			};



			updateOrAddMapImage(newImage);
			populateFormieFormImageField(event.detail.formie.$forms[0]);
		}
	}
});

function updateOrAddMapImage(newImage) {
  const index = mapImages.findIndex(image => image.id === newImage.id);

  if (index !== -1) {
    // If an object with the same ID exists, replace it
    mapImages[index] = newImage;
  } else {
    // If no object with the same ID exists, add the new image
    mapImages.push(newImage);
  }
}

function populateFormieFormAddressFields(formieFormEl, addressParts) {
	formieFormEl.querySelector('[name="fields[address]"]').value = addressParts.fullAddress;
}

/*
function populateFormieFormImageField(formieFormEl) {
	formieFormEl.querySelector('[name="fields[mapImages]"]').value = mapImages.map(image => image.src).join('\n');
}
	*/

function populateFormieFormImageField(formieFormEl) {
	formieFormEl.querySelector('[name="fields[mapImages]"]').value = mapImages.map(image => {
			return `<a href="${image.src}">${image.alt || 'Image'}</a>`;
	}).join('\n');
}

function getGeoJson(feature) {
	let geojson = feature;
	geojson.properties = {
		"stroke-width": 6,
		"fill-opacity": 0.4,
		"fill": '#2E67B1',
		"stroke":'#2E67B1'
	}
	return encodeURIComponent(JSON.stringify(geojson));
}